
interface SymbolProps {
    symbol: React.ReactNode;
    className?: string;
}

export default function Symbol ({ symbol, className }: SymbolProps) {
    const circleClass = className || "circle";
    return (
        <div className={`d-flex justify-content-center align-items-center ${circleClass} p-3 symbol-font`}>
            {symbol}
        </div>
    )
}